"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * TextCell - Composant texte responsive
 * La navigation interne est gérée par le CellWrapper parent
 */const TextCell = ({
  text,
  styles_properties = {},
  className = '',
  style = {},
  as = 'p',
  link_to,
  action_log,
  scaleFactor = 1,
  ...rest
}) => {
  // Styles du conteneur avec scaleFactor appliqué aux tailles
  const containerStyle = {
    backgroundColor: styles_properties.background_color,
    color: styles_properties.text_color,
    fontSize: styles_properties.font_size ? `${styles_properties.font_size * scaleFactor}px` : undefined,
    fontFamily: styles_properties.text_font,
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius * scaleFactor}px` : undefined,
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width * scaleFactor}px` : undefined,
    borderStyle: styles_properties.border_style,
    padding: styles_properties.padding ? `${styles_properties.padding * scaleFactor}px` : undefined,
    opacity: styles_properties.opacity,
    textAlign: styles_properties.text_align,
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    ...style
  };
  const isClickable = !!link_to;
  const containerClasses = ['text-cell', isClickable && 'text-cell--clickable', className].filter(Boolean).join(' ');

  // Créer l'élément texte avec la balise appropriée
  const TextTag = as;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: containerClasses,
    style: {
      cursor: isClickable ? 'pointer' : 'default'
    },
    "data-action-log": action_log,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TextTag, {
      className: "text-cell__content",
      style: containerStyle,
      children: text
    })
  });
};
var _default = exports.default = TextCell;